<template>
  <div>
    <div class="mini-breadcrumbs">
      <span class="courses-link" @click="$router.push(`/manager/courses`)">
        All Learning Resources
      </span>
      &middot;
      <span class="course-link" @click="$router.push(`/courses/${course.id}`)">
        This Course
      </span>
    </div>
    <base-badge
      :imageUrl="badgeUrl"
      class="center-align"
      style="padding-top: 10px;"
    ></base-badge>
    <base-learning-view
      :id="item.id"
      :body="item.body"
      :description="item.description"
      :name="item.name"
      :enableComplete="enableComplete"
      :showComplete="showComplete"
      :status="item.status"
      :showTemplates="false"
      :nextItemId="item.next_id"
    />
    <h3 class="my-4" v-if="item.documents && item.documents.length > 0">
      Resource Documents
    </h3>
    <base-list
      :userType="userType"
      :listItems="item.documents"
      :showAdd="false"
      :showDelete="false"
      :link="setLink"
      :linksAsDownloads="true"
    />
    <div v-if="responsesComplete">
      <base-learning-responses-complete :responses="responses" />
    </div>
    <div v-else>
      <base-learning-response-view :responses="responses" />
    </div>
  </div>
</template>
<script>
import BaseLearningView from "@/components/BaseLearningView"
import BaseLearningResponsesComplete from "@/components/BaseLearningResponsesComplete"
import BaseLearningResponseView from "@/components/BaseLearningResponseView"
import BaseList from "@/components/BaseList"
import BaseBadge from "@/components/BaseBadge"
import User from "@/lib/user"

export default {
  components: {
    BaseLearningView,
    BaseLearningResponsesComplete,
    BaseLearningResponseView,
    BaseList,
    BaseBadge
  },
  props: {
    item: { type: Object, default: () => {} },
    showComplete: { type: Boolean, default: false },
    responsesComplete: { type: Boolean, default: false }
  },
  methods: {
    setLink(el) {
      return el.url
    }
  },
  computed: {
    enableComplete() {
      // the item has no responses
      if (!this.item.responses || this.item.responses.length == 0) {
        return true
      }
      // the item has responses, and each response contains at least some value
      return this.item.responses.every(el => el.value && el.value.length > 0)
    },
    responses() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.learningItemId
      )
      return item && item.responses ? item.responses : []
    },
    badgeUrl() {
      let item = this.$store.getters["learningItems/getLearningItemById"](
        this.learningItemId
      )
      return item ? item.badge_url : ""
    },
    course() {
      let course = this.$store.getters["courses/getCourseByLearningItemId"](
        this.learningItemId
      )
      return course
    }
  },
  data() {
    return {
      learningItemId: this.$route.params.id,
      userType: User.getUserType(),
      showDelete: !User.isMember()
    }
  },
  created() {
    this.$store.dispatch("courses/loadCourses")
    // console.log('learning_items/loadLearningItem: ' + this.learningItemId)
    // this.$store.dispatch("learningItems/loadLearningItem", this.learningItemId)
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.center-align {
  display: flex;
  justify-content: center;
}

.course-link,
.courses-link {
  cursor: pointer;
  font-weight: 300;
  font-style: italic;
  color: $light-yellow;
}

.course-link:hover,
.courses-link:hover {
  color: $dark-blue;
}

.mini-breadcrumbs {
  color: $orange;
  font-size: 1.2em;
}
</style>
